import { useParams } from 'react-router-dom'
import BlockDetailIndex from './index'
const AccountDetail = () => {
  const { dynamic } = useParams()
  return <BlockDetailIndex key={dynamic} />
}

export default AccountDetail
